module.exports = __webpack_public_path__ + "img/jiGuang3.259e4f7e.png";